const basicCommune = {
  id: '',
  name: '',
  code: '',
  provinceId: ''
};

export default basicCommune;
